'use client';
import CampaignRecords from './CampaignRecords'; // 中獎紀錄、獎勵
import CampaignSpin from './CampaignSpin'; // 轉盤
import CampaignWinningList from './CampaignWinningList'; // 得獎名單彈窗

const CampaignClientPop = ({ roulettes, drawTime, spinSlug, bonus }) => {
    return (
        <>
            {/* 玩家個人中獎紀錄彈窗 */}
            <CampaignRecords />

            {/* 遊戲轉盤 */}
            <CampaignSpin
                roulettes={roulettes}
                drawTime={drawTime}
                spinSlug={spinSlug}
                bonus={bonus}
            />

            {/* 得獎名單彈窗 */}
            <CampaignWinningList spinSlug={spinSlug} />
        </>
    );
};

export default CampaignClientPop;
